import { Directionality } from "@angular/cdk/bidi";
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { Platform } from "@angular/cdk/platform";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Host,
  Inject,
  Input,
  Optional,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzSubMenuComponent } from "ng-zorro-antd/menu";
import { UiMenuItemDirective } from "../../directives/menu-item.directive";
import { UiMenuService } from "../../services/menu.service";
import { UiSubmenuService } from "../../services/submenu.service";
import { UiIsMenuInsideDropDownToken } from "../../utils/menu.utils";

@Component({
  selector: "[ui-submenu]",
  exportAs: "uiSubmenu",
  providers: [UiSubmenuService],
  templateUrl: "./submenu-component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSubmenuComponent extends NzSubMenuComponent {
  @Input("uiClassName") public nzMenuClassName = "";
  @Input("uiPaddingLeft") public nzPaddingLeft: number | null = null;
  @Input("uiTitle") public nzTitle: string | TemplateRef<void> | null = null;
  @Input("uiIcon") public nzIcon: string | null = null;
  @Input("uiOpen") @InputBoolean() public nzOpen = false;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Output("uiOpenChange") public readonly nzOpenChange: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(CdkOverlayOrigin, { static: true, read: ElementRef }) public cdkOverlayOrigin: ElementRef | null = null;
  @ContentChildren(NzSubMenuComponent, { descendants: true })
  public listOfNzSubMenuComponent: QueryList<NzSubMenuComponent> | null = null;
  @ContentChildren(UiMenuItemDirective, { descendants: true })
  public listOfNzMenuItemDirective: QueryList<UiMenuItemDirective> | null = null;

  constructor(
    public uiMenuService: UiMenuService,
    cdr: ChangeDetectorRef,
    public uiSubmenuService: UiSubmenuService,
    platform: Platform,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean,
    @Optional() directionality: Directionality,
    @Host() @Optional() noAnimation?: NzNoAnimationDirective
  ) {
    super(uiMenuService, cdr, uiSubmenuService, platform, isMenuInsideDropDown, directionality, noAnimation);
  }
}
